import useQueryClientCallback from '@/hooks/useQueryClientCallback'
import { updateServiceEntityName } from '@/modules/Service/services'
import { Service } from '@/modules/Service/types'
import { IPermissionProps } from '@/types/shared'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm } from 'vnetwork-ui'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

interface ServiceTechnicalProps extends IPermissionProps {
    service: Service
    label?: string
}

const ServiceTechnicalComponent: React.FC<ServiceTechnicalProps> = ({
    service,
    label,
}) => {
    const { t } = useTranslation()
    const { refetch } = useQueryClientCallback({
        reactQueryKeys: [`services`],
    })

    const { mutateAsync, isPending } = useMutationWithHandler(
        {
            mutationFn: updateServiceEntityName,
        },
        {
            successMessage: t('update-service-entity-name-success'),
            reactQueryKeys: QUERY_KEYS.SERVICES,
            onSuccess() {
                refetch()
            },
        }
    )

    const formControl = useForm<{
        name: string
    }>({
        defaultValues: {
            name: service?.name || '',
        },
    })

    const onSubmit = async (values: { name: string }) => {
        mutateAsync({ serviceID: service?.service_id, name: values?.name })
    }

    return (
        <div className="p-4 bg-white mt-2 rounded-[8px]">
            <GridHookForm
                formControl={formControl}
                data={[
                    {
                        formItemProps: {
                            name: 'name',
                            type: 'textfield',
                            helperText: label || t('helper-text-entity-name'),
                            label: label || t('entity-name'),
                            placeholder: label || t('entity-name'),
                        },
                    },
                ]}
                actions={[
                    {
                        title: t('submit'),
                        type: 'submit',
                        disabled: !formControl.formState?.isDirty || isPending,
                        loading: isPending,
                        variant: 'contained',
                    },
                ]}
                onSubmit={onSubmit}
            />
        </div>
    )
}

export default ServiceTechnicalComponent
